import { routes } from '@spa/core/router'
import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

const onboardingPages = [
  routes.comboPayOnboardingLocationFlow.rootPath,
  routes.comboPayOnboardingOverview.rootPath
]

export const showZendeskWidget = () => {
  ;(window as any)?.zE?.('webWidget', 'show')
  ;(window as any)?.zE?.('webWidget', 'open')
}

export const hideZendeskWidget = () => {
  ;(window as any)?.zE?.('webWidget', 'hide')
}

/**
 * Check if the current location is an onboarding page
 */
export const useZendeskMatchOnboardingRoutes = () => {
  const location = useLocation()
  return onboardingPages.some(page => matchPath(page, location.pathname))
}

/**
 * Hide Zendesk widget when leaving onboarding pages
 */
export const useHideZendeskOnLeaveOnboarding = () => {
  const isOnboardingPage = useZendeskMatchOnboardingRoutes()

  useEffect(() => {
    if (!isOnboardingPage) {
      hideZendeskWidget()
    }
  }, [isOnboardingPage])
}
